import BASE_URL from '@/components/constants';
export const getHomeHeadingList = async (section) => {
  const url = `${BASE_URL}/v1/filter/get/${section}?page=1&limit=500`;
  try {
    const res = await fetch(url, { cache: 'no-store' });
    const data = await res.json();
    return data.data;
  } catch (err) {
    console.log('Error:', err);
  } finally {
  }
};

export const getHotDeal = async () => {
  const url = `${BASE_URL}/v1/cms/get-hot-deal-products?page=1&limit=6`;
  try {
    const res = await fetch(url, { cache: 'no-store' });
    const data = await res.json();
    return data.productList;
  } catch (err) {
    console.log('Error while fetching hot deal', err);
  } finally {
  }
};

export const getTodayHotDeal = async () => {
  const url = `${BASE_URL}/v1/products/get-all-products?page=1&limit=6&hot_deal=true`;
  try {
    const res = await fetch(url, { cache: 'no-store' });
    const data = await res.json();
    return data.productList;
  } catch (err) {
    console.log('Error while fetching today hot deal', err);
  } finally {
  }
};

export const getSingleProduct = async (id) => {
  const url = `${BASE_URL}/v1/products/get-product/${id}`;
  try {
    const res = await fetch(url, { cache: 'no-cache' });
    const data = await res.json();
    return data;
  } catch (err) {
    console.log('Error while fetching single product', err);
  } finally {
  }
};

export const getBlogs = async () => {
  try {
    const response = await fetch(`${BASE_URL}/v1/blog/get`);
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching blogs:', error);
  }
};

export const getSeodata = async (pageName) => {
  if (!pageName) return null
  const res = await fetch(`${BASE_URL}/v1/seo/get/single?pageName=${pageName}&usecache=true`, { cache: 'no-cache' })
  const data = await res.json()
  if (data.success) {
    return data.seoData
  }
}

export const getAllCountry = async () => {
  try {
    const response = await fetch(`${BASE_URL}/v1/filter/get-all/country?page=1&limit=100`, { cache: 'no-store' });
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching countries:', error);
  }
};

export const getSingleCountry = async (slug) => {
  try {
    const response = await fetch(`${BASE_URL}/v1/country/country/${slug}`, { cache: 'no-store' });
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching single country:', error);
  }
};
export const getAllAward = async () => {
  try {
    const response = await fetch(`${BASE_URL}/v1/filter/get-all/award?page=1&limit=500`, { cache: 'no-store' });
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching awards:', error);
  }
}


export const getSingleAward = async (slug) => {
  try {
    const response = await fetch(`${BASE_URL}/v1/product-awards/get/slug/${slug}`, { cache: 'no-store' });
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching single award:', error);
  }
}

export const getPlusContent = async (url) => {
  try {
    const response = await fetch(`${BASE_URL}${url}`, { cache: 'no-store' });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching single award:', error);
  }
}

export const getPromotinPagedata = async (url) => {
  try {
    const response = await fetch(`${BASE_URL}${url}`, { cache: 'no-store' });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching single award:', error);
  }
}


export const getAllProduct = async (url) => {
  try {
    const response = await fetch(`${BASE_URL}${url}`, { cache: 'no-store' });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching single award:', error);
  }
}